<section class="w-full">
	@for (section of resolvedSections(); track section.xtype) {
	<ng-container [ngComponentOutlet]="section.component" />
	}
</section>
